import { render } from "./MessagePage.vue?vue&type=template&id=bb3f178a&scoped=true"
import script from "./MessagePage.vue?vue&type=script&lang=js"
export * from "./MessagePage.vue?vue&type=script&lang=js"

import "./MessagePage.vue?vue&type=style&index=0&id=bb3f178a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3f178a"]])

export default __exports__